if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			this.pickupOnlyGuardVariantId = 48324050485496;

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

			this.initCheckoutPickupGuard();
			this.initFuneralCartModule();

		}

		initCheckoutPickupGuard() {
			if ( ! this.form ) return;

			if ( this._checkoutGuardBoundForm && this._checkoutGuardBoundForm !== this.form && this._checkoutSubmitHandler ) {
				this._checkoutGuardBoundForm.removeEventListener('submit', this._checkoutSubmitHandler);
			}

			if ( this._checkoutGuardBoundButton && this._checkoutClickHandler ) {
				this._checkoutGuardBoundButton.removeEventListener('click', this._checkoutClickHandler);
			}

			if ( this._checkoutGuardBoundForm !== this.form ) {
				this._checkoutSubmitHandler = this.onCheckoutSubmit.bind(this);
				this.form.addEventListener('submit', this._checkoutSubmitHandler);
				this._checkoutGuardBoundForm = this.form;
			}

			const checkoutButton = this.form.querySelector('#CheckOut');
			if ( checkoutButton ) {
				this._checkoutClickHandler = (event) => {
					event.preventDefault();
					this.onCheckoutSubmit();
				};
				checkoutButton.addEventListener('click', this._checkoutClickHandler);
				this._checkoutGuardBoundButton = checkoutButton;
			}
		}

		async onCheckoutSubmit(event) {
			if ( event && this._programmaticCheckoutSubmit ) {
				return;
			}

			if ( event ) {
				event.preventDefault();
			}

			if ( this._checkoutPickupGuardRunning ) return;
			this._checkoutPickupGuardRunning = true;

			const checkoutButton = this.form ? this.form.querySelector('#CheckOut') : null;
			this.setCheckoutLoadingState(checkoutButton, true);

			try {
				await this.runPickupGuardSyncFailSafe();
			} catch (error) {
				console.log(error);
			} finally {
				this.submitCheckoutForm();
			}
		}

		setCheckoutLoadingState(checkoutButton, isLoading) {
			if ( this.form ) {
				this.form.classList.toggle('processing', isLoading);
			}
			if ( checkoutButton ) {
				checkoutButton.disabled = isLoading;
				checkoutButton.classList.toggle('disabled', isLoading);
				checkoutButton.classList.toggle('working', isLoading);
			}
		}

		async runPickupGuardSyncFailSafe() {
			const timeoutMs = 2500;
			let timeoutHandle;
			const timeoutPromise = new Promise(resolve => {
				timeoutHandle = window.setTimeout(resolve, timeoutMs);
			});

			try {
				await Promise.race([this.syncPickupOnlyGuardItem(), timeoutPromise]);
			} catch (error) {
				console.log(error);
			} finally {
				window.clearTimeout(timeoutHandle);
			}
		}

		submitCheckoutForm() {
			if ( ! this.form ) return;

			this._programmaticCheckoutSubmit = true;
			const checkoutInput = document.createElement('input');
			checkoutInput.type = 'hidden';
			checkoutInput.name = 'checkout';
			checkoutInput.value = 'checkout';
			this.form.append(checkoutInput);
			this.form.submit();

			window.setTimeout(() => {
				this._programmaticCheckoutSubmit = false;
				this._checkoutPickupGuardRunning = false;
				this.setCheckoutLoadingState(this.form.querySelector('#CheckOut'), false);
				checkoutInput.remove();
			}, 1500);
		}

		async syncPickupOnlyGuardItem() {
			const cartItems = Array.from(this.querySelectorAll('[data-js-cart-item]'));
			const guardItems = cartItems.filter(item => item.dataset.pickupGuardItem === 'true');
			const hasPickupOnlyItems = cartItems.some(item => item.dataset.pickupGuardItem !== 'true' && item.dataset.pickupOnly === 'true');

			if ( hasPickupOnlyItems ) {
				if ( guardItems.length === 0 ) {
					await this.addPickupGuardItem();
					return;
				}

				for ( let i = 0; i < guardItems.length; i++ ) {
					const guardItem = guardItems[i];
					if ( i === 0 ) {
						const guardQty = parseInt(guardItem.dataset.qty || '1', 10);
						if ( Number.isNaN(guardQty) || guardQty !== 1 ) {
							await this.changeCartItemByKey(guardItem.dataset.id, 1);
						}
					} else {
						await this.changeCartItemByKey(guardItem.dataset.id, 0);
					}
				}
			} else {
				for ( const guardItem of guardItems ) {
					await this.changeCartItemByKey(guardItem.dataset.id, 0);
				}
			}
		}

		async addPickupGuardItem() {
			const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body: JSON.stringify({
					items: [
						{
							id: this.pickupOnlyGuardVariantId,
							quantity: 1,
							properties: {
								_pickup_guard: 'true'
							}
						}
					]
				})
			});
			if ( ! response.ok ) {
				throw new Error('Impossible d ajouter la ligne pickup guard');
			}
		}

		async changeCartItemByKey(itemKey, quantity) {
			if ( ! itemKey ) return;
			const response = await fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body: JSON.stringify({
					id: itemKey,
					quantity: quantity
				})
			});
			if ( ! response.ok ) {
				throw new Error('Impossible de synchroniser la ligne pickup guard');
			}
		}

		initFuneralCartModule() {
			const moduleRoot = document.querySelector('[data-funeral-cart-module]');
			if ( ! moduleRoot ) return;

			const select = moduleRoot.querySelector('[data-funeral-cart-select]');
			const attributeInput = moduleRoot.querySelector('[data-funeral-cart-attribute]');
			const customSelect = moduleRoot.querySelector('[data-funeral-cart-custom-select]');
			const trigger = moduleRoot.querySelector('[data-funeral-cart-trigger]');
			const menu = moduleRoot.querySelector('[data-funeral-cart-menu]');
			const triggerThumb = moduleRoot.querySelector('[data-funeral-cart-trigger-thumb]');
			const triggerImage = moduleRoot.querySelector('[data-funeral-cart-trigger-image]');
			const triggerLabel = moduleRoot.querySelector('[data-funeral-cart-trigger-label]');
			const triggerPrice = moduleRoot.querySelector('[data-funeral-cart-trigger-price]');
			const otherAddressGroup = moduleRoot.querySelector('[data-funeral-cart-other-address-group]');
			const otherAddressInput = moduleRoot.querySelector('[data-funeral-cart-other-address-input]');
			const otherAddressOutput = moduleRoot.querySelector('[data-funeral-cart-other-address-output]');
			const otherAddressConfirm = moduleRoot.querySelector('[data-funeral-cart-other-address-confirm]');
			const otherAddressFeedback = moduleRoot.querySelector('[data-funeral-cart-other-address-feedback]');
			if ( ! select ) return;
			const uiRefs = {
				triggerThumb,
				triggerImage,
				triggerLabel,
				triggerPrice,
				otherAddressGroup,
				otherAddressInput,
				otherAddressOutput,
				otherAddressConfirm,
				otherAddressFeedback
			};

			let options = this.parseFuneralOptions(moduleRoot.dataset.funeralOptions || '[]');
			if ( ! Array.isArray(options) ) {
				options = [];
			}
			if ( options.length === 0 && Array.isArray(window.__configuredFuneralDeliveryOptions) ) {
				options = window.__configuredFuneralDeliveryOptions;
			}
			if ( options.length > 0 ) {
				window.__configuredFuneralDeliveryOptions = options;
			}
			console.info('[FuneralCart] Initialisation module', {
				selectedVariantId: moduleRoot.dataset.selectedVariantId || '',
				optionsCount: options.length,
				options: options
			});
			this.renderFuneralRatesTable(moduleRoot, options);

			select.innerHTML = '<option value="">Choisir un salon</option>';
			if ( menu ) {
				menu.innerHTML = '';
			}

			options.forEach((option) => {
				if ( ! option || ! option.variantId ) return;
				const optionElement = document.createElement('option');
				optionElement.value = String(option.variantId);
				optionElement.dataset.label = option.label || '';
				optionElement.dataset.image = option.image || '';
				optionElement.dataset.price = option.price || '';
				optionElement.textContent = option.price ? `${option.label} - ${option.price}` : (option.label || '');
				select.append(optionElement);

				if ( menu ) {
					const menuItem = document.createElement('button');
					menuItem.type = 'button';
					menuItem.className = 'funeral-cart-module__custom-item';
					menuItem.dataset.variantId = optionElement.value;
					menuItem.dataset.label = optionElement.dataset.label;
					menuItem.dataset.image = optionElement.dataset.image;
					menuItem.dataset.price = optionElement.dataset.price;

					if ( optionElement.dataset.image ) {
						const thumb = document.createElement('span');
						thumb.className = 'funeral-cart-module__custom-item-thumb';
						const image = document.createElement('img');
						image.src = optionElement.dataset.image;
						image.alt = optionElement.dataset.label;
						thumb.append(image);
						menuItem.append(thumb);
					}

					const label = document.createElement('span');
					label.className = 'funeral-cart-module__custom-item-label';
					label.textContent = optionElement.dataset.label;
					menuItem.append(label);

					const price = document.createElement('span');
					price.className = 'funeral-cart-module__custom-item-price';
					price.textContent = optionElement.dataset.price;
					menuItem.append(price);

					menuItem.addEventListener('click', () => {
						select.value = menuItem.dataset.variantId || '';
						if ( trigger ) {
							trigger.setAttribute('aria-expanded', 'false');
						}
						if ( menu ) {
							menu.classList.add('hide');
						}
						this.syncFuneralOption(select, attributeInput, moduleRoot, uiRefs);
					});

					menu.append(menuItem);
				}
			});

			if ( menu && options.length === 0 ) {
				const emptyState = document.createElement('div');
				emptyState.className = 'funeral-cart-module__custom-item';
				emptyState.textContent = 'Aucune option disponible. Reajoutez un article funeraire.';
				menu.append(emptyState);
				console.warn('[FuneralCart] Aucune option disponible pour le dropdown.');
			}

			const selectedVariantId = moduleRoot.dataset.selectedVariantId ? String(moduleRoot.dataset.selectedVariantId) : '';
			if ( selectedVariantId ) {
				select.value = selectedVariantId;
			}

			if ( customSelect && trigger && menu ) {
				trigger.addEventListener('click', () => {
					const isOpen = ! menu.classList.contains('hide');
					menu.classList.toggle('hide', isOpen);
					trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				});

				if ( this._funeralOutsideClickHandler ) {
					document.removeEventListener('click', this._funeralOutsideClickHandler);
				}
				this._funeralOutsideClickHandler = (event) => {
					if ( ! customSelect.contains(event.target) ) {
						menu.classList.add('hide');
						trigger.setAttribute('aria-expanded', 'false');
					}
				};
				document.addEventListener('click', this._funeralOutsideClickHandler);
			}

			this.syncFuneralOptionUI(select, attributeInput, uiRefs);
			select.addEventListener('change', () => {
				this.syncFuneralOption(select, attributeInput, moduleRoot, uiRefs);
			});
			if ( otherAddressInput ) {
				otherAddressInput.addEventListener('input', () => {
					this.syncFuneralOptionUI(select, attributeInput, uiRefs);
				});
			}
			if ( otherAddressConfirm ) {
				otherAddressConfirm.addEventListener('click', () => {
					this.confirmFuneralOtherAddress(select, uiRefs);
				});
			}
		}

		parseFuneralOptions(rawValue) {
			const candidates = [];
			const safeRaw = String(rawValue || '[]').trim();
			candidates.push(safeRaw);
			candidates.push(
				safeRaw
					.replace(/&quot;/g, '"')
					.replace(/&#34;/g, '"')
					.replace(/&#39;/g, "'")
					.replace(/&apos;/g, "'")
					.replace(/&amp;/g, '&')
			);

			for ( const candidate of candidates ) {
				try {
					const parsed = JSON.parse(candidate);
					return Array.isArray(parsed) ? parsed : [];
				} catch (error) {
					// continue with next candidate
				}
			}

			console.warn('[FuneralCart] JSON options invalides dans data-funeral-options.', safeRaw);
			return [];
		}

		renderFuneralRatesTable(moduleRoot, options) {
			const ratesBody = moduleRoot.querySelector('[data-funeral-rates-body]');
			if ( ! ratesBody ) return;

			ratesBody.innerHTML = '';
			const validOptions = options.filter((option) => option && option.label && option.price);

			if ( validOptions.length === 0 ) {
				const row = document.createElement('tr');
				const cell = document.createElement('td');
				cell.colSpan = 2;
				cell.textContent = 'Aucun tarif disponible.';
				row.append(cell);
				ratesBody.append(row);
				return;
			}

			validOptions.forEach((option) => {
				const row = document.createElement('tr');
				const labelCell = document.createElement('td');
				const priceCell = document.createElement('td');
				labelCell.textContent = option.label;
				priceCell.textContent = option.price;
				row.append(labelCell, priceCell);
				ratesBody.append(row);
			});
		}

		syncFuneralOptionUI(select, attributeInput, uiRefs) {
			const selectedOption = select.options[select.selectedIndex];
			const selectedLabel = selectedOption && selectedOption.value ? (selectedOption.dataset.label || selectedOption.textContent || '') : '';
			const selectedImage = selectedOption && selectedOption.value ? (selectedOption.dataset.image || '') : '';
			const selectedPrice = selectedOption && selectedOption.value ? (selectedOption.dataset.price || '') : '';

			if ( attributeInput ) {
				attributeInput.value = selectedOption && selectedOption.value ? selectedLabel : '';
			}

			if ( uiRefs.triggerLabel ) {
				uiRefs.triggerLabel.textContent = selectedLabel || 'Choisir un salon';
			}
			if ( uiRefs.triggerThumb ) {
				uiRefs.triggerThumb.classList.toggle('hide', !selectedImage);
			}
			if ( uiRefs.triggerImage ) {
				uiRefs.triggerImage.src = selectedImage;
				uiRefs.triggerImage.alt = selectedLabel;
			}
			if ( uiRefs.triggerPrice ) {
				uiRefs.triggerPrice.textContent = selectedPrice;
				uiRefs.triggerPrice.classList.toggle('hide', !selectedPrice);
			}
			const isOtherOption = /autres/i.test(selectedLabel);
			if ( uiRefs.otherAddressGroup ) {
				uiRefs.otherAddressGroup.classList.toggle('hide', !isOtherOption);
			}
			if ( uiRefs.otherAddressInput ) {
				uiRefs.otherAddressInput.disabled = !isOtherOption;
				if ( !isOtherOption ) {
					uiRefs.otherAddressInput.value = '';
				}
			}
			if ( uiRefs.otherAddressOutput ) {
				uiRefs.otherAddressOutput.disabled = !isOtherOption;
				uiRefs.otherAddressOutput.value = isOtherOption && uiRefs.otherAddressInput ? uiRefs.otherAddressInput.value : '';
			}
			if ( uiRefs.otherAddressConfirm ) {
				uiRefs.otherAddressConfirm.classList.toggle('hide', !isOtherOption);
			}
			if ( uiRefs.otherAddressFeedback && !isOtherOption ) {
				this.setFuneralAddressFeedback(uiRefs, '');
			}
		}

		setFuneralAddressFeedback(uiRefs, message, type = '') {
			if ( ! uiRefs || ! uiRefs.otherAddressFeedback ) return;
			const feedback = uiRefs.otherAddressFeedback;
			feedback.textContent = message || '';
			feedback.classList.remove('funeral-cart-module__other-address-feedback--error', 'funeral-cart-module__other-address-feedback--success');
			if ( type === 'error' ) {
				feedback.classList.add('funeral-cart-module__other-address-feedback--error');
			} else if ( type === 'success' ) {
				feedback.classList.add('funeral-cart-module__other-address-feedback--success');
			}
			feedback.classList.toggle('hide', !message);
		}

		async confirmFuneralOtherAddress(select, uiRefs) {
			const selectedOption = select ? select.options[select.selectedIndex] : null;
			const selectedVariantId = selectedOption && selectedOption.value ? parseInt(selectedOption.value, 10) : NaN;
			const selectedLabel = selectedOption && selectedOption.value ? (selectedOption.dataset.label || selectedOption.textContent || '') : '';
			const isOtherOption = /autres/i.test(selectedLabel);
			const addressValue = uiRefs && uiRefs.otherAddressInput ? uiRefs.otherAddressInput.value.trim() : '';

			if ( ! isOtherOption || Number.isNaN(selectedVariantId) ) {
				this.setFuneralAddressFeedback(uiRefs, 'Choisissez un salon Autres avant de confirmer.', 'error');
				return;
			}
			if ( ! addressValue ) {
				this.setFuneralAddressFeedback(uiRefs, 'Entrez une adresse avant de confirmer.', 'error');
				return;
			}

			if ( uiRefs && uiRefs.otherAddressConfirm ) {
				uiRefs.otherAddressConfirm.disabled = true;
			}
			this.setFuneralAddressFeedback(uiRefs, '');

			try {
				const funeralFeeItems = Array.from(document.querySelectorAll('[data-js-cart-item][data-funeral-fee-item="true"]'));
				const matchingFeeItem = funeralFeeItems.find((feeItem) => parseInt(feeItem.dataset.variantId || '', 10) === selectedVariantId);
				if ( ! matchingFeeItem ) {
					this.setFuneralAddressFeedback(uiRefs, 'Selectionnez d abord le salon pour mettre a jour l adresse.', 'error');
					return;
				}

				const feeQuantity = parseInt(matchingFeeItem.dataset.qty || '1', 10);
				await fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body: JSON.stringify({
						id: matchingFeeItem.dataset.id,
						quantity: Number.isNaN(feeQuantity) ? 1 : feeQuantity,
						properties: {
							_funeral_fee: 'true',
							_funeral_option: selectedLabel,
							'Adresse du salon': addressValue
						}
					})
				});
				this.setFuneralAddressFeedback(uiRefs, 'Adresse enregistrée pour la livraison au salon funéraire.', 'success');
			} catch (error) {
				console.log(error);
				this.setFuneralAddressFeedback(uiRefs, 'Impossible d enregistrer l adresse pour le moment.', 'error');
			} finally {
				if ( uiRefs && uiRefs.otherAddressConfirm ) {
					uiRefs.otherAddressConfirm.disabled = false;
				}
			}
		}

		async syncFuneralOption(select, attributeInput, moduleRoot, uiRefs) {
			const selectedOption = select.options[select.selectedIndex];
			const selectedVariantId = selectedOption && selectedOption.value ? parseInt(selectedOption.value, 10) : NaN;
			const selectedLabel = selectedOption && selectedOption.value ? (selectedOption.dataset.label || selectedOption.textContent || '') : '';
			console.info('[FuneralCart] Changement de selection', {
				selectedVariantId: Number.isNaN(selectedVariantId) ? null : selectedVariantId,
				selectedLabel: selectedLabel
			});

			this.syncFuneralOptionUI(select, attributeInput, uiRefs);

			select.disabled = true;
			if ( uiRefs && uiRefs.triggerLabel ) {
				const triggerButton = uiRefs.triggerLabel.closest('button');
				if ( triggerButton ) {
					triggerButton.disabled = true;
				}
			}

			try {
				const funeralFeeItems = Array.from(document.querySelectorAll('[data-js-cart-item][data-funeral-fee-item="true"]'));
				console.info('[FuneralCart] Lignes frais funeraire detectees', {
					count: funeralFeeItems.length,
					items: funeralFeeItems.map((feeItem) => ({
						key: feeItem.dataset.id,
						variantId: feeItem.dataset.variantId
					}))
				});
				for ( const feeItem of funeralFeeItems ) {
					const feeItemVariantId = parseInt(feeItem.dataset.variantId || '', 10);
					const shouldRemove = Number.isNaN(selectedVariantId) || feeItemVariantId !== selectedVariantId;
					if ( shouldRemove ) {
						console.info('[FuneralCart] Suppression ligne frais funeraire', {
							key: feeItem.dataset.id,
							variantId: feeItemVariantId
						});
						await fetch(KROWN.settings.routes.cart_change_url, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body: JSON.stringify({
								id: feeItem.dataset.id,
								quantity: 0
							})
						});
					}
				}

				if ( ! Number.isNaN(selectedVariantId) ) {
					const existingFeeItem = funeralFeeItems.find((feeItem) => parseInt(feeItem.dataset.variantId || '', 10) === selectedVariantId);
					if ( ! existingFeeItem ) {
						console.info('[FuneralCart] Ajout ligne frais funeraire', {
							variantId: selectedVariantId,
							label: selectedLabel
						});
						await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body: JSON.stringify({
								items: [
									{
										id: selectedVariantId,
										quantity: 1,
										properties: {
											_funeral_fee: 'true',
											_funeral_option: selectedLabel
										}
									}
								]
							})
						});
					}
				}

				const sectionResponse = await fetch('?section_id=helper-cart');
				console.info('[FuneralCart] Refresh helper-cart apres maj livraison funeraire.');
				const text = await sectionResponse.text();
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				document.dispatchEvent(new CustomEvent("zapiet:start"));
				const event = new Event('cart-updated');
				this.dispatchEvent(event);
			} catch (error) {
				console.log(error);
			} finally {
				select.disabled = false;
				if ( uiRefs && uiRefs.triggerLabel ) {
					const triggerButton = uiRefs.triggerLabel.closest('button');
					if ( triggerButton ) {
						triggerButton.disabled = false;
					}
				}
			}
		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.dispatchEvent(new CustomEvent("zapiet:start"))		
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}